import { useState, useEffect } from 'react';

export const useCrewViewOrientation = () => {
  const [showPortraitPopup, setShowPortraitPopup] = useState(false);
  const [portraitPopupShown, setPortraitPopupShown] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      const isMobileOrTablet = window.matchMedia('(max-width: 1024px)').matches;
      const isPortrait = window.matchMedia('(orientation: portrait)').matches;

      if (isMobileOrTablet && isPortrait && !portraitPopupShown) {
        setShowPortraitPopup(true);
        setPortraitPopupShown(true);
      } else if (!isPortrait) {
        setShowPortraitPopup(false);
        setPortraitPopupShown(false);
      }
    };

    checkOrientation();

    window.addEventListener('orientationchange', checkOrientation);
    window.addEventListener('resize', checkOrientation);

    return () => {
      window.removeEventListener('orientationchange', checkOrientation);
      window.removeEventListener('resize', checkOrientation);
    };
  }, [portraitPopupShown]);

  return {
    showPortraitPopup
  };
};
